import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PaginationListResponse } from 'src/app/_models/pagination-list-response';
import { environment } from 'src/environments/environment';
import { GetDetallesEmpresaResponse } from '../../admin/responses/get-detalles-empresa-response';
import { GetEmpresasAfiliadasResponse } from '../../admin/responses/get-empresas-afiliadas-response';
import { InsertOfertaTrabajoExternaRequest } from '../../docente/requests/insert-oferta-trabajo-externa-request';
import { InsertOfertaTrabajoExternaResponse } from '../../docente/responses/insert-oferta-trabajo-externa-response';
import { DeleteOfertaTrabajoActivaRequest } from '../../empresa/requests/delete-oferta-activa-request';
import { UpdateEstadoPostulacionRequest } from '../../empresa/requests/update-estado-postulacion-request';
import { DeleteOfertaTrabajoActivaResponse } from '../../empresa/responses/delete-oferta-activa-response';
import { GetEmpresaDetallesPostuladoResponse } from '../../empresa/responses/get-detalles-postulante-response';
import { PostEmpresaImageResponse } from '../../empresa/responses/get-imagepath-response';
import { UpdateEstadoPostulacionResponse } from '../../empresa/responses/update-estado-postulacion-response';
import { InsertConocimientoEgresadoRequest } from '../requests/insert-con-egr-request';
import { InsertEgresadoExpLaboralRequest } from '../requests/insert-exp-lab-request';
import { InsertHabilidadEgresadoRequest } from '../requests/insert-hab-egr-request';
import { InsertEgresadoPostulacionRequest } from '../requests/insert-postulacion-egr-request';
import { UpdateEgresadoDatosPersonalesRequest } from '../requests/update-datos-egr-request';
import { UpdatePasswordEgresadoRequest } from '../requests/update-password-egr-request';
import { UpdatePerfilEgresadoRequest } from '../requests/update-perfil-egr-request';
import { GetEgresadoInfoPersonalResponse } from '../responses/get-datos-egr-personales-response';
import { GetOfertasTrabajoDetalleResponse } from '../responses/get-detalles-oferta-egr-response';
import { GetEgresadoPostulacionesResponse } from '../responses/get-egresado-postulaciones-response';
import { GetEgresadoFiltroDescripcionPuestoResponse } from '../responses/get-filtro-desponse';
import { PostEgresadoImageResponse } from '../responses/get-imagepath-response';
import { GetEgresadoBasicInfoResponse } from '../responses/get-info-basic-egr-response';
import { GetEgresadoInfoPerfilResponse } from '../responses/get-info-perfil-egr-response';
import { ListaOfertasParaEgresadoResponse } from '../responses/get-notificacion-oferta-response';
import { ReadOfertasActivasFiltroEgresadoResponse } from '../responses/get-ofertas-activas-egr-filtro-response';
import { GetEgresadoListaOfertasActivasResponse } from '../responses/get-ofertas-activas-egr-response';
import { GetEgresadoOfertasHistorialResponse } from '../responses/get-ofertas-historial-egr-response';
import { GetEmpresaOfertasRevisionResponse } from '../responses/get-ofertas-revision-egr-response';
import { GetPostulacionExistenteEgresadoResponse } from '../responses/get-post-exist-egr-response';
import { InsertConocimientoEgresadoResponse } from '../responses/insert-con-egr-response';
import { InsertEgresadoExpLaboralResponse } from '../responses/insert-exp-lab-response';
import { InsertHabilidadEgresadoResponse } from '../responses/insert-hab-egr-response';
import { InsertEgresadoPostulacionResponse } from '../responses/insert-postulacion-egr-response';
import { UpdateEgresadoDatosPersonalesResponse } from '../responses/update-datos-egr-response';
import { UpdatePasswordEgresadoResponse } from '../responses/update-password-egr-response';
import { UpdatePerfilEgresadoResponse } from '../responses/update-perfil-egr-response';
import { UpdateEgresadoRedesRequest } from '../requests/update-red-egr-request';

@Injectable({
  providedIn: 'root'
})
export class EgresadoService implements OnDestroy {
  controller = 'CuentaEgresado';
  private destroy$: Subject<void> = new Subject<void>();
  
  constructor(private _http: HttpClient) {}

  subirFotografia(idUsuario: number, archivo: File): Observable<PostEgresadoImageResponse> {
    let formData = new FormData();
    formData.append('formFile', archivo, archivo.name);
  
    let params = new HttpParams().set('idusuario', idUsuario.toString());
  
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
  
    let options = { headers: headers, params: params };
  
    return this._http.post<PostEgresadoImageResponse>(
      `${environment.url_api}${this.controller}/upload-image`,
      formData,
      options
    ).pipe(takeUntil(this.destroy$));
  }


  subirFotografiaDetalle(archivo: File): Observable<PostEmpresaImageResponse> {
    let formData = new FormData();
    formData.append('formFile', archivo, archivo.name);
  
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
  
    let options = { headers: headers};
  
    return this._http.post<PostEmpresaImageResponse>(
      `${environment.url_api}${this.controller}/upload-detalle-image`,
      formData,
      options
    ).pipe(takeUntil(this.destroy$));
  }
  
  
    agregarHabilidad(request: InsertHabilidadEgresadoRequest): Observable<InsertHabilidadEgresadoResponse> {
      return this._http.post<InsertHabilidadEgresadoResponse>(
        `${environment.url_api}${this.controller}/add-habilidad-egresado`,
        request
      ).pipe(takeUntil(this.destroy$));
    }

    agregarConocimiento(request: InsertConocimientoEgresadoRequest): Observable<InsertConocimientoEgresadoResponse> {
      return this._http.post<InsertConocimientoEgresadoResponse>(
        `${environment.url_api}${this.controller}/add-conocimiento-egresado`,
        request
      ).pipe(takeUntil(this.destroy$));
    }  


    actualizarPassword(request: UpdatePasswordEgresadoRequest): Observable<UpdatePasswordEgresadoResponse> {
      return this._http.put<UpdatePasswordEgresadoResponse>(
        `${environment.url_api}${this.controller}/update-password`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 

    actualizarDatos(request: UpdateEgresadoDatosPersonalesRequest): Observable<UpdateEgresadoDatosPersonalesResponse> {
      return this._http.put<UpdateEgresadoDatosPersonalesResponse>(
        `${environment.url_api}${this.controller}/update-datos-personales`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 

    agregarExperienciaLab(request: InsertEgresadoExpLaboralRequest): Observable<InsertEgresadoExpLaboralResponse> {
      return this._http.post<InsertEgresadoExpLaboralResponse>(
        `${environment.url_api}${this.controller}/add-experiencia-laboral-egresado`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 

    crearOferta(request: InsertOfertaTrabajoExternaRequest): Observable<InsertOfertaTrabajoExternaResponse> {
      return this._http.post<InsertOfertaTrabajoExternaResponse>(
        `${environment.url_api}${this.controller}/crear-oferta`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 

    actualizarPerfil(request: UpdatePerfilEgresadoRequest): Observable<UpdatePerfilEgresadoResponse> {
      return this._http.put<UpdatePerfilEgresadoResponse>(
        `${environment.url_api}${this.controller}/update-perfil`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 

    cancelarOfertaActiva(request: DeleteOfertaTrabajoActivaRequest): Observable<DeleteOfertaTrabajoActivaResponse> {
      return this._http.put<DeleteOfertaTrabajoActivaResponse>(
        `${environment.url_api}${this.controller}/borrar-oferta-activa`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 

    actualizarPostulacion(request: UpdateEstadoPostulacionRequest): Observable<UpdateEstadoPostulacionResponse> {
      return this._http.put<UpdateEstadoPostulacionResponse>(
        `${environment.url_api}${this.controller}/actualizar-estado-postulacion`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 

    getDatosPersonales(request: number): Observable<GetEgresadoInfoPersonalResponse> {
      let parameters = { idUsuario : request};
      return this._http.get<GetEgresadoInfoPersonalResponse>(
        `${environment.url_api}${this.controller}/get-datos-personales`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    } 

    getInformacionBasica(request: number): Observable<GetEgresadoBasicInfoResponse> {
      let parameters = { idUsuario : request};
      return this._http.get<GetEgresadoBasicInfoResponse>(
        `${environment.url_api}${this.controller}/get-informacion-basica`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    } 

    getInfoPerfil(request: number): Observable<GetEgresadoInfoPerfilResponse> {
      let parameters = { idUsuario : request};
      return this._http.get<GetEgresadoInfoPerfilResponse>(
        `${environment.url_api}${this.controller}/get-info-completo`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }   

    getPostulacionesEgresado(request: number): Observable<PaginationListResponse<GetEgresadoPostulacionesResponse>> {
      let parameters = { idUsuario : request};
      return this._http.get<PaginationListResponse<GetEgresadoPostulacionesResponse>>(
        `${environment.url_api}${this.controller}/get-postulaciones-egresado`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }   

    getPostulacionesEgresadoByPage(request: number,page): Observable<PaginationListResponse<GetEgresadoPostulacionesResponse>> {
      let parameters = { idUsuario : request,'skip':page.toString()};
      return this._http.get<PaginationListResponse<GetEgresadoPostulacionesResponse>>(
        `${environment.url_api}${this.controller}/get-postulaciones-egresado`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }   

    getOfertasActivas(request: number): Observable<PaginationListResponse<GetEgresadoListaOfertasActivasResponse>> {
      let parameters = { idUsuario : request};
      return this._http.get<PaginationListResponse<GetEgresadoListaOfertasActivasResponse>>(
        `${environment.url_api}${this.controller}/get-ofertas-activas`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }  

    getOfertasActivasByPage(request: number,page): Observable<PaginationListResponse<GetEgresadoListaOfertasActivasResponse>> {
      let parameters = { idUsuario : request,'skip':page.toString()};
      return this._http.get<PaginationListResponse<GetEgresadoListaOfertasActivasResponse>>(
        `${environment.url_api}${this.controller}/get-ofertas-activas`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }
    
    

    getOfertasActivasFiltro(request: number): Observable<PaginationListResponse<ReadOfertasActivasFiltroEgresadoResponse>> {
      let parameters = { idUsuario : request};
      return this._http.get<PaginationListResponse<ReadOfertasActivasFiltroEgresadoResponse>>(
        `${environment.url_api}${this.controller}/get-ofertas-activas-filtro`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }   

    getOfertasActivasFiltroByPage(request: number,page:number): Observable<PaginationListResponse<ReadOfertasActivasFiltroEgresadoResponse>> 
    {
      let parameters = { idUsuario : request,'skip':page.toString()};
      return this._http.get<PaginationListResponse<ReadOfertasActivasFiltroEgresadoResponse>>(
        `${environment.url_api}${this.controller}/get-ofertas-activas-filtro`,{params:parameters}
      );
    }

    getOfertasRevision(request: number): Observable<PaginationListResponse<GetEmpresaOfertasRevisionResponse>> {
      let parameters = { idUsuario : request};
      return this._http.get<PaginationListResponse<GetEmpresaOfertasRevisionResponse>>(
        `${environment.url_api}${this.controller}/obtener-ofertas-revision`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }  
    
    getOfertasRevisionByPage(request: number,page): Observable<PaginationListResponse<GetEmpresaOfertasRevisionResponse>> {
      let parameters = { idUsuario : request,'skip':page.toString()};
      return this._http.get<PaginationListResponse<GetEmpresaOfertasRevisionResponse>>(
        `${environment.url_api}${this.controller}/obtener-ofertas-revision`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    } 


    getOfertasHistorial(request: number): Observable<PaginationListResponse<GetEgresadoOfertasHistorialResponse>> {
      let parameters = { idUsuario : request};
      return this._http.get<PaginationListResponse<GetEgresadoOfertasHistorialResponse>>(
        `${environment.url_api}${this.controller}/obtener-ofertas-historial`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }  

    getOfertasHistorialByPage(request: number,page): Observable<PaginationListResponse<GetEgresadoOfertasHistorialResponse>> {
      let parameters = { idUsuario : request,'skip':page.toString()};
      return this._http.get<PaginationListResponse<GetEgresadoOfertasHistorialResponse>>(
        `${environment.url_api}${this.controller}/obtener-ofertas-historial`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }  
    

    getDetallesOferta(request: number): Observable<GetOfertasTrabajoDetalleResponse> {
      let parameters = { idOferta : request};
      return this._http.get<GetOfertasTrabajoDetalleResponse>(
        `${environment.url_api}${this.controller}/get-detalles-oferta`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    }  

    insertOfertaTrabajoExterna(request:InsertOfertaTrabajoExternaRequest): Observable<InsertOfertaTrabajoExternaResponse> {
      return this._http.post<InsertOfertaTrabajoExternaResponse>(
        `${environment.url_api}${this.controller}/crear-oferta`,request
      ).pipe(takeUntil(this.destroy$));
    }

    getEmpresasAfiliadas(): Observable<PaginationListResponse<GetEmpresasAfiliadasResponse>> {
      return this._http.get<PaginationListResponse<GetEmpresasAfiliadasResponse>>(
        `${environment.url_api}${this.controller}/list-empresas-afiliadas`      
      ).pipe(takeUntil(this.destroy$));
    }

    getEmpresasAfiliadasByPage(page): Observable<PaginationListResponse<GetEmpresasAfiliadasResponse>> {
      let parameters = { 'skip' : page.toString()};  
      return this._http.get<PaginationListResponse<GetEmpresasAfiliadasResponse>>(
        `${environment.url_api}${this.controller}/list-empresas-afiliadas`,
        {params:parameters}     
      ).pipe(takeUntil(this.destroy$));
    }
  
    getDetallesEmpresa(idUsuario:number): Observable<GetDetallesEmpresaResponse> {
      let parameters = { idUsuarioEmpresa: idUsuario };
      return this._http.get<GetDetallesEmpresaResponse>(
        `${environment.url_api}${this.controller}/detalles-empresa`,
        { params: parameters }
      ).pipe(takeUntil(this.destroy$));
    }

    getDetallesPostulante(idUsuario: number): Observable<GetEmpresaDetallesPostuladoResponse> {
      let parameters = { idUsuario : idUsuario};
      return this._http.get<GetEmpresaDetallesPostuladoResponse>(
        `${environment.url_api}${this.controller}/obtener-detalles-postulado`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    } 

    postularseOferta(request: InsertEgresadoPostulacionRequest): Observable<InsertEgresadoPostulacionResponse> {
      return this._http.post<InsertEgresadoPostulacionResponse>(
        `${environment.url_api}${this.controller}/add-postulacion-egresado`,
        request
      ).pipe(takeUntil(this.destroy$));
    } 
    
    getFiltroDescripcion(descripcion): Observable<GetEgresadoFiltroDescripcionPuestoResponse[]> {
      let parameters = { descripcion : descripcion};
      return this._http.get<GetEgresadoFiltroDescripcionPuestoResponse[]>(
        `${environment.url_api}${this.controller}/obtener-filtro-descripcion`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    } 


    getOffersBySearch(idUsuario,lugar,descripcion): Observable<ReadOfertasActivasFiltroEgresadoResponse[]> {
      let parameters = { idUsuario : idUsuario,
                         place : lugar,
                         description : descripcion};
      return this._http.get<ReadOfertasActivasFiltroEgresadoResponse[]>(
        `${environment.url_api}${this.controller}/get-ofertas-activas-filtro-estado-puesto`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    } 

    getPostulacionExistente(idOferta:number , idUsuario:number): Observable<GetPostulacionExistenteEgresadoResponse> {
      let parameters = { idOferta : idOferta,
                         idUsuario : idUsuario};
      return this._http.get<GetPostulacionExistenteEgresadoResponse>(
        `${environment.url_api}${this.controller}/obtener-postulacion-existente`,
        {params:parameters}
      ).pipe(takeUntil(this.destroy$));
    } 

    getNotificationOfertas(): Observable<ListaOfertasParaEgresadoResponse[]> {
      return this._http.get<ListaOfertasParaEgresadoResponse[]>(
        `${environment.url_api}${this.controller}/offer-list-graduated`
      ).pipe(takeUntil(this.destroy$));
    } 

    actualizarRedesSociales(request: UpdateEgresadoRedesRequest): Observable<boolean> {
      return this._http.put<boolean>(
        `${environment.url_api}${this.controller}/actualizar-redes`,
        request
      ).pipe(takeUntil(this.destroy$));
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }